<template>
  <div class="relative rating-wrapper">
  <vx-card class="rating">
    <div class="vx-row flex">
      <div class="vx-col p-0 flex items-center">
        <div class="google-logo">
          <google-logo />
        </div>
      </div>
      <div class="vx-col pr-0">
        <div class="rating_title ">Google Rating</div>
        <div class="p-0 flex">
            <span class="rating_value">{{item.rating}}</span>
            <star-rating :show-rating="false" :rating="item.rating" active-color="#e7711b" :star-size="20" read-only />
        </div>
      </div>
    </div>
  </vx-card>
  </div>
</template>

<script>
import StarRating from 'vue-star-rating'
import GoogleLogo from './GoogleLogo'
export default {
  props: {
    item: {
      type: Object
    }
  },
  components: {
    StarRating,
    GoogleLogo
  },
  directives: {
  },
  name: 'Reviews',
  data () {
    return {
    }
  },
  computed: {
  },
  watch: {
  },
  methods: {
  },
  mounted () {
  }
}
</script>

<style lang="scss">
  .rating {
    width: max-content;
    margin:0 auto;
    .rating_value {

      color: #e7711b;
      font-size: 20px;
      margin: 0 6px 0 0;
      vertical-align: middle;
    }
    .vx-card__body {
      padding: 6px !important;
    }
    .google-logo {
      width: 36px;
      height: 36px;
    }
    .vx-card {

      box-shadow: unset;
    }
  }

  .rating-wrapper {
    height: max-content;
    margin-bottom:20px;
  }
</style>
